import styled from 'styled-components'

export const StaffTypeWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 20px;
`

export const StaffTypeTitle = styled.div`
  text-align: center;
  text-transform: uppercase;
`

export const StaffsBoxWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
`

export const StaffBox = styled.div`
  background-color: white;
  border-radius: 10px;
  padding: 20px 20px;
  margin-bottom: 16px;
  display: flex;
  flex-flow: column;
`

export const StaffBoxItemWrapper = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
`

export const StaffItemCardBtns = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
`

export const StaffCardContent = styled.ul`
  list-style: none;
  padding-inline-start: 0;
`
